class shopifyFormUtilities {
    
        constructor() {
            this.emailChangeEvent = new Event('input');
            this.submitEvent = new Event('submit');
            this.customerEmail = document.querySelector('body').getAttribute('data-customer-email');
            this.customerID = document.querySelector('body').getAttribute('data-customer-id');
        }
    
        _populateForm(shadowDOM, selectedData,partsNumber) {
            if (!shadowDOM) {
                // Exit if shadowDOM is not defined
                return;
            }
            const emailInput = shadowDOM.querySelector('#email');
            const customerIDEl = shadowDOM.getElementById('custom#customer_id');
            const textarea = shadowDOM.querySelector('textarea');
            const form = shadowDOM.querySelector('form');
    
            if (emailInput && customerIDEl && textarea && form) {
                emailInput.value = this.customerEmail;
                emailInput.dispatchEvent(this.emailChangeEvent);
    
                customerIDEl.value = this.customerID;
                customerIDEl.dispatchEvent(this.emailChangeEvent);
    
                textarea.value = JSON.stringify(selectedData);
                textarea.dispatchEvent(this.emailChangeEvent);
    
                form.dispatchEvent(this.submitEvent);
                let checkFormSubmitStatus = setInterval(() => {
                    if(shadowDOM.querySelector('[data-testid="banner-success"]')) {
                        clearInterval(checkFormSubmitStatus)
                        //window.location.reload();
                      
                        if(partsNumber){
                            this._redirectToParts(partsNumber);
                        } else {
                            window.location.reload();
                        }
                    }
                }, 1000);
            } else {
                console.error('Form elements not found');
            }
        }

        async allVehicleUpdate(selectedYMMData,selectedHeavyEqipData,selectedTrufData,selectedSideYMMData,selectedSahdtData,partsNumber) {
            let customerID = document.querySelector('body').getAttribute('data-customer-id');
            const dataArray = [
                {
                    "customer_id": customerID,
                    "meta_key": "model_selection",
                    "meta_value": JSON.stringify(selectedYMMData)
                },
                {
                    "customer_id": customerID,
                    "meta_key": "heavy_model_selection",
                    "meta_value": JSON.stringify(selectedHeavyEqipData)
                },
                {
                    "customer_id": customerID,
                    "meta_key": "side_model_selection",
                    "meta_value": JSON.stringify(selectedSideYMMData)
                },
                {
                    "customer_id": customerID,
                    "meta_key": "agri_and_turf_model_selection",
                    "meta_value": JSON.stringify(selectedTrufData)
                },
                {
                    "customer_id": customerID,
                    "meta_key": "semi_seat_cover_data",
                    "meta_value": JSON.stringify(selectedSahdtData)
                }
            ];

            try {
                const promises = dataArray.map(data => fetch('/tools/tiger-tough-custom-api/update-customer-metafields',{
                    method: 'POST',
                    body: JSON.stringify(data),
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json",
                    }
                }).then(response => response.json()));
                const results = await Promise.all(promises);
                // console.log('Data fetched:', results,results.ok);
                if(partsNumber){
                    this._redirectToParts(partsNumber);
                } else {
                    window.location.reload();
                }
            } catch (error) {
                console.error('Error fetching data:', error);
                window.location.reload();
            }
        
           
        }

        async _updateVehicleMeta(selectedYMMData, partsNumber) {
          
            let customerID = document.querySelector('body').getAttribute('data-customer-id');
            var data = {
                "customer_id": customerID,
                "meta_key": "model_selection",
                "meta_value": JSON.stringify(selectedYMMData)
            };
        
            try {
                const response = await fetch('/tools/tiger-tough-custom-api/update-customer-metafields', {
                    method: 'POST',
                    body: JSON.stringify(data),
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json",
                    }
                });
        
                
                if (response.ok) {
                    // Response is OK, proceed to redirect
                    if(partsNumber){
                        this._redirectToParts(partsNumber);
                    } else {
                        window.location.reload();
                    }

                } else {
                    // Handle failure (optional: reload page or show message)
                    console.error('Failed to update customer metafields:', response.status, response.statusText);
                    window.location.reload(); // Optional: you can choose to reload the page or handle differently
                }
            } catch (error) {
                // Handle any other errors that might occur during the fetch request
                console.error('An error occurred:', error);
            }
        }
    
    
        _shopifyVehicleFormSubmit(selectedYMMData,partsNumber) {
            
            const shadowDOM = document.querySelector('[data-forms-id="forms-root-39955"] #app-embed')?.shadowRoot;
            if (!shadowDOM) {
                // Exit if shadowDOM is not defined
                return;
            }
            this._populateForm(shadowDOM, selectedYMMData,partsNumber);
        }

      
        _shopifyHEFormSubmit(selectedHeavyEqipData,partsNumber) {
            
            const shadowDOM = document.querySelector('[data-forms-id="forms-root-41087"] #app-embed')?.shadowRoot;
            if (!shadowDOM) {
                // Exit if shadowDOM is not defined
                return;
            }
            this._populateForm(shadowDOM, selectedHeavyEqipData,partsNumber);
        }

        async _updateCustomerHEMeta(selectedHeavyEqipData, partsNumber) {
            let customerID = document.querySelector('body').getAttribute('data-customer-id');
            var data = {
                "customer_id": customerID,
                "meta_key": "heavy_model_selection",
                "meta_value": JSON.stringify(selectedHeavyEqipData)
            };
        
            try {
                const response = await fetch('/tools/tiger-tough-custom-api/update-customer-metafields', {
                    method: 'POST',
                    body: JSON.stringify(data),
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json",
                    }
                });
        
                if (response.ok) {
                    // Response is OK, proceed to redirect or handle based on partsNumber
                    if (partsNumber) {
                        this._redirectToParts(partsNumber);
                    } else {
                        window.location.reload();
                    }
                } else {
                    // Handle failure (optional: reload page or show message)
                    console.error('Failed to update customer metafields:', response.status, response.statusText);
                    window.location.reload(); // Optional: you can choose to reload the page or handle differently
                }
            } catch (error) {
                // Handle any other errors that might occur during the fetch request
                console.error('An error occurred:', error);
            }
        }

        _shopifySideFormSubmit(selectedSideData,partsNumber) {
            
            const shadowDOM = document.querySelector('[data-forms-id="forms-root-91794"] #app-embed')?.shadowRoot;
            if (!shadowDOM) {
                // Exit if shadowDOM is not defined
                return;
            }
            this._populateForm(shadowDOM, selectedSideData,partsNumber);
        }

        async _updateCustomerSideMeta(selectedSideYMMData, partsNumber) {
            let customerID = document.querySelector('body').getAttribute('data-customer-id');
            var data = {
                "customer_id": customerID,
                "meta_key": "side_model_selection",
                "meta_value": JSON.stringify(selectedSideYMMData)
            };
        
            try {
                const response = await fetch('/tools/tiger-tough-custom-api/update-customer-metafields', {
                    method: 'POST',
                    body: JSON.stringify(data),
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json",
                    }
                });
        
                if (response.ok) {
                    // Response is OK, proceed to redirect or handle based on partsNumber
                    if (partsNumber) {
                        this._redirectToParts(partsNumber);
                    } else {
                        window.location.reload();
                    }
                } else {
                    // Handle failure (optional: reload page or show message)
                    console.error('Failed to update customer metafields:', response.status, response.statusText);
                    window.location.reload(); // Optional: you can choose to reload the page or handle differently
                }
            } catch (error) {
                // Handle any other errors that might occur during the fetch request
                console.error('An error occurred:', error);
            }
        }
    
        _shopifyTurfFormSubmit(selectedTurfData,partsNumber) {
           
            const shadowDOM = document.querySelector('[data-forms-id="forms-root-109636"] #app-embed')?.shadowRoot;
            if (!shadowDOM) {
                // Exit if shadowDOM is not defined
                return;
            }
            this._populateForm(shadowDOM, selectedTurfData,partsNumber);
        }

        async _updateCustomerTurfMeta(selectedTrufData, partsNumber) {
            let customerID = document.querySelector('body').getAttribute('data-customer-id');
            var data = {
                "customer_id": customerID,
                "meta_key": "agri_and_turf_model_selection",
                "meta_value": JSON.stringify(selectedTrufData)
            };
        
            try {
                const response = await fetch('/tools/tiger-tough-custom-api/update-customer-metafields', {
                    method: 'POST',
                    body: JSON.stringify(data),
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json",
                    }
                });
        
                if (response.ok) {
                    // Response is OK, proceed to redirect or handle based on partsNumber
                    if (partsNumber) {
                        this._redirectToParts(partsNumber);
                    } else {
                        window.location.reload();
                    }
                } else {
                    // Handle failure (optional: reload page or show message)
                    console.error('Failed to update customer metafields:', response.status, response.statusText);
                    window.location.reload(); // Optional: you can choose to reload the page or handle differently
                }
            } catch (error) {
                // Handle any other errors that might occur during the fetch request
                console.error('An error occurred:', error);
            }
        }

        _shopifySemiAndHeavyDutyFormSubmit(selectedSAHDTYMMData, partsNumber) {
           
            const shadowDOM = document.querySelector('[data-forms-id="forms-root-136222"] #app-embed')?.shadowRoot;
            if (!shadowDOM) {
                // Exit if shadowDOM is not defined
                return;
            }
            this._populateForm(shadowDOM, selectedSAHDTYMMData, partsNumber);
        }

        async _updateCustomerSHeavyMeta(selectedSahdtData, partsNumber) {
            let customerID = document.querySelector('body').getAttribute('data-customer-id');
            var data = {
                "customer_id": customerID,
                "meta_key": "semi_seat_cover_data",
                "meta_value": JSON.stringify(selectedSahdtData)
            };
        
            try {
                const response = await fetch('/tools/tiger-tough-custom-api/update-customer-metafields', {
                    method: 'POST',
                    body: JSON.stringify(data),
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json",
                    }
                });
        
                if (response.ok) {
                    // Response is OK, proceed to redirect or handle based on partsNumber
                    if (partsNumber) {
                        this._redirectToParts(partsNumber);
                    } else {
                        window.location.reload();
                    }
                } else {
                    // Handle failure (optional: reload page or show message)
                    console.error('Failed to update customer metafields:', response.status, response.statusText);
                    window.location.reload(); // Optional: you can choose to reload the page or handle differently
                }
            } catch (error) {
                // Handle any other errors that might occur during the fetch request
                console.error('An error occurred:', error);
            }
        }

        _redirectToParts(partsNumber){
            window.location.href=`/collections/all?filter.p.tag=${partsNumber}`;
        }


  }
  
  var shopifyFormUtility = new shopifyFormUtilities();
  